import DownloadOutlined from '@mui/icons-material/DownloadOutlined';
import MoreHorizOutlined from '@mui/icons-material/MoreHorizOutlined';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { MouseEvent, ReactElement } from 'react';

import { Menu } from '../Menu/Menu';

type Props = {
  title: string;
  updatedAt: string;
  menuItems: ReactElement[];
  onDownload: (event: MouseEvent<HTMLButtonElement>) => void;
};

export const DocumentCard = ({ title, updatedAt, menuItems, onDownload }: Props) => {
  return (
    <Box
      sx={{
        alignItems: 'center',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        display: 'flex',
        justifyContent: 'space-between',
        p: 2,
      }}
    >
      <Box>
        <Typography
          variant="subtitle1"
          sx={{
            fontSize: '16px',
            fontWeight: 700,
          }}
        >
          {title}
        </Typography>
        <Typography
          color="secondary"
          sx={{
            fontSize: '14px',
            fontWeight: 400,
          }}
        >
          {updatedAt}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', gap: 1 }}>
        <IconButton size="small" onClick={onDownload}>
          <DownloadOutlined />
        </IconButton>
        <Menu
          equalMenuWidth={false}
          button={
            <IconButton size="small">
              <MoreHorizOutlined />
            </IconButton>
          }
        >
          {menuItems}
        </Menu>
      </Box>
    </Box>
  );
};
